import React from "react";
import { Spinner } from "react-bootstrap";
import logo from "../assets/images/round_logo.png";

const Loader = () => {
  return (
    <div className="loader-common">
      <img
        src={logo}
        alt="logoImg"
        className="loaderLogo"
        style={{ opacity: 1 }}
      />
      <Spinner animation="grow" className="loaderSpinner" />
    </div>
  );
};

export default Loader;
